import { buildQueryString } from '../utils/request';

const AFFILIATE_API_BASE = process.env.AFFILIATE_API;
const AUTH_HEADER = process.env.LAMBDA_AUTH_HEADER;
const AUTH_VALUE = process.env.LAMBDA_AUTH_HEADER_VALUE;

export default {
  async search(params) {
    const queryString = buildQueryString({
      affiliate: 'fanatics',
      ...params,
    });

    const resp = await fetch(`${AFFILIATE_API_BASE}/search${queryString}`, {
      headers: {
        [AUTH_HEADER]: AUTH_VALUE,
      },
    });

    if (!resp.ok) {
      const err = await resp.json();
      throw new Error(err?.message || err || 'Failed to complete fanatics search');
    }

    return resp.json();
  },

  async makeAffiliateLink(url, params) {
    const resp = await fetch(`${AFFILIATE_API_BASE}/link`, {
      method: 'POST',
      headers: {
        [AUTH_HEADER]: AUTH_VALUE,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        affiliate: 'fanatics',
        link: url,
        ...params,
      }),
    });

    if (!resp.ok) {
      const err = await resp.json();
      throw new Error(err?.message || err || 'Failed to get fanatics link');
    }

    const data = await resp.json();
    
    return data.link;
  },
};
